/* global Blockly */
import React from 'react';
import MobiControlCore from './MobiControlCore';

function defineBlock(context) {
    let prop = {...context};
    prop.blockText = "get device ID";
    prop.tooltipText = "Get device ID from MobiControl.";
    prop.responseText = "device ID";
    prop.responseBlockType = "text_response";
    let blockInstance = MobiControlCore(prop);
    return blockInstance;
}

function defineGenerators() {
    return {
        'JavaScript': function (block) {
            let coreResponseCode = block.getJavascriptCore();
            return `Snap.mcDeviceDetails.getDeviceId(${coreResponseCode});\n`;
        }
    }
}

const MobiControlGetDeviceId = function (props) {
    const name = 'snap_mobicontrol_getdeviceid';
    MobiControlGetDeviceId.blockName = name;

    Blockly.Blocks[name] = defineBlock(props.context);
    let generators = defineGenerators(props.context);
    for (let i in generators) {
        Blockly[i][name] = generators[i];
    }

    return <block type={name}></block>;
}

export default MobiControlGetDeviceId;